"use strict";
import styled from "lib/styled-components";
import { BREAKPOINTS } from "theme";
import { useTranslation } from "react-i18next";
const FooterWrapper = styled.footer`
  width: 100%;
  background-color: ${({ theme }) => theme.surface1};
  border-top: 1px solid ${({ theme }) => theme.surface3};
  margin-top: auto;
`;
const FooterContent = styled.div`
  width: 100%;
  padding: 48px 48px 24px;

  @media screen and (max-width: ${BREAKPOINTS.md}px) {
    padding: 32px 24px 16px;
  }

  @media screen and (max-width: ${BREAKPOINTS.sm}px) {
    padding: 24px 16px 16px;
  }
`;
const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 48px;
  margin-bottom: 32px;

  @media screen and (max-width: ${BREAKPOINTS.md}px) {
    grid-template-columns: 1fr;
    gap: 32px;
  }
`;
const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const LogoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
const LogoImage = styled.img`
  width: 32px;
  height: 32px;
`;
const LogoText = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: ${({ theme }) => theme.neutral1};
`;
const SectionTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.neutral1};
  margin-bottom: 8px;
`;
const FooterLink = styled.a`
  font-size: 14px;
  color: ${({ theme }) => theme.neutral2};
  text-decoration: none;
  transition: color 0.2s;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.accent1};
  }
`;
const Copyright = styled.div`
  padding-top: 24px;
  border-top: 1px solid ${({ theme }) => theme.surface3};
  font-size: 14px;
  color: ${({ theme }) => theme.neutral2};
  text-align: center;

  @media screen and (max-width: ${BREAKPOINTS.md}px) {
    padding-top: 16px;
    font-size: 12px;
  }
`;
export default function Footer() {
  const { t } = useTranslation();
  return <FooterWrapper><FooterContent><FooterGrid>{
    /* Logo Section */
  }<FooterSection><LogoSection><LogoImage src="/images/logos/logo.svg" alt="H2 Chain logo" /><LogoText>H2 Chain</LogoText></LogoSection></FooterSection>{
    /* Company Section */
  }<FooterSection><SectionTitle>{t("footer.company")}</SectionTitle><FooterLink href="https://h2chain.io/about">{t("footer.aboutUs")}</FooterLink><FooterLink href="https://community.h2chain.io">{t("footer.contactUs")}</FooterLink></FooterSection>{
    /* Products Section */
  }<FooterSection><SectionTitle>{t("footer.products")}</SectionTitle>{
    /* <FooterLink href="/">{t('footer.h2swap')}</FooterLink> */
  }<FooterLink href="https://h2scan.io" target="_blank" rel="noopener noreferrer">{t("footer.h2explorer")}</FooterLink><FooterLink href="https://h2bridge.net">{t("footer.h2bridge")}</FooterLink><FooterLink href="https://stake.h2chain.io">{t("footer.h2news")}</FooterLink></FooterSection></FooterGrid><Copyright>
          © {(/* @__PURE__ */ new Date()).getFullYear()} {t("footer.copyright")}</Copyright></FooterContent></FooterWrapper>;
}
